import { Fade } from '@mui/material';

import NotAuthLayout from 'layouts/not-auth-layout';

import ViewDocument from './components/view-document';

export default function PublicShared() {
  return (
    <NotAuthLayout>
      <Fade in={true}>
        <div>
          <ViewDocument />
        </div>
      </Fade>
    </NotAuthLayout>
  );
}
